import { yupResolver } from '@hookform/resolvers/yup';
import { Alert, Button, FormControl, TextField } from '@mui/material';
import { Stack } from '@mui/system';
import { SwipableDialog } from '@tix-ticketing/ui-components';
import { useEffect, useState } from 'react';
import { useForm, type SubmitHandler } from 'react-hook-form';
import { FormattedMessage, useIntl } from 'react-intl';
import * as yup from 'yup';
import { useApplyDiscountCode } from 'lib/hooks/use-apply-discount-code';
interface DiscountCodeDialogProps {
  open: boolean;
  onClose: () => void;
  encryptedOrderId?: string | null;
  onApplied: () => void;
}
interface Input {
  code: string;
}
export const DiscountCodeDialog = ({
  open,
  onClose,
  encryptedOrderId,
  onApplied
}: DiscountCodeDialogProps) => {
  const intl = useIntl();
  const [warning, setWarning] = useState<string | null>(null);
  const schema = yup.object({
    code: yup.string().trim().required()
  }).required();
  const {
    register,
    handleSubmit,
    setFocus,
    reset,
    formState: {
      errors
    }
  } = useForm<Input>({
    resolver: yupResolver(schema)
  });
  useEffect(() => {
    if (open) {
      setWarning(null);
      reset({
        code: ''
      });
      setTimeout(() => {
        setFocus('code');
      }, 100);
    }
  }, [setFocus, reset, open]);
  const mutation = useApplyDiscountCode();
  const invalidCodeMessage = intl.formatMessage({
    id: "cart.discountCode.invalid",
    defaultMessage: [{
      "type": 0,
      "value": "This code isn't valid."
    }]
  });
  const showWarning = (message?: string | null) => {
    setWarning(message || invalidCodeMessage);
    setFocus('code');
  };
  const onSubmit: SubmitHandler<Input> = ({
    code
  }) => {
    if (!encryptedOrderId) return;
    setWarning(null);
    mutation.mutate({
      encryptedOrderId,
      code
    }, {
      onSuccess: (data: any) => {
        if (data.status !== 200) {
          showWarning(data.response?.data?.detail);
          return;
        }
        onApplied();
        onClose();
      },
      onError: (error: any) => showWarning(error?.response?.data?.detail)
    });
  };
  return <SwipableDialog open={open} onClose={onClose} maxWidth="sm" headerText={intl.formatMessage({
    id: "cart.discountCode.label",
    defaultMessage: [{
      "type": 0,
      "value": "Discount code"
    }]
  })} subtitleText={intl.formatMessage({
    id: "cart.discountCode.dialogSubtitle",
    defaultMessage: [{
      "type": 0,
      "value": "Enter a code to apply a discount to your cart"
    }]
  })} primaryActionButton={<Button type="submit" size="large" variant="contained" fullWidth loading={mutation.isPending} onClick={handleSubmit(onSubmit)}>
          <FormattedMessage id="common.apply" defaultMessage={[{
      "type": 0,
      "value": "Apply"
    }]} />
        </Button>}>
      <form onSubmit={handleSubmit(onSubmit)}>
        <Stack spacing={3} sx={{
        alignItems: 'center'
      }}>
          <FormControl sx={{
          width: '100%'
        }}>
            <TextField error={!!errors.code} id="code" label={intl.formatMessage({
            id: "cart.discountCode.inputLabel",
            defaultMessage: [{
              "type": 0,
              "value": "Code"
            }]
          })} type="text" fullWidth color={warning ? 'warning' : 'primary'} {...register('code')} />
          </FormControl>
          {warning && <Alert severity="warning" sx={{
          width: '100%'
        }}>
              {warning}
            </Alert>}
        </Stack>
      </form>
    </SwipableDialog>;
};